export default __webpack_public_path__ + "408e1ee8df06196dba4c3f43a0890947.png";